// ─── Label definitions ────────────────────────────────────────────────────────

export const LABELS = {
  epitaph: {
    name: 'Epitaph Records',
    color: 'text-red-400',
    bg: 'bg-red-400/10',
    border: 'border-red-400/20',
    pressContact: 'Riot Act Media (Epitaph PR)',
    pressEmail: 'press@epitaph.com',
    website: 'https://epitaph.com',
    artists: [
      'Bad Religion', 'Pennywise', 'Rancid', 'AFI', 'Alkaline Trio',
      'Hot Water Music', 'The Menzingers', 'Drug Church', 'Knocked Loose',
      'Movements', 'Touche Amore', 'Joyce Manor', 'The Bouncing Souls',
      'Descendents', 'Dropkick Murphys', 'Saves the Day',
    ],
  },
  roadrunner: {
    name: 'Roadrunner Records',
    color: 'text-orange-400',
    bg: 'bg-orange-400/10',
    border: 'border-orange-400/20',
    pressContact: 'Roadrunner Records PR',
    pressEmail: 'press@roadrunnerrecords.com',
    website: 'https://roadrunnerrecords.com',
    artists: [
      'Slipknot', 'Trivium', 'Killswitch Engage', 'Gojira', 'Hatebreed',
      'Code Orange', 'All That Remains', 'Bullet for My Valentine', 'Opeth',
      'Dream Theater', 'Motionless in White', 'Light the Torch', 'Crowbar',
      'Fear Factory', 'Sepultura', 'The Amity Affliction', 'Bad Omens', 'Spiritbox',
    ],
  },
  trustkill: {
    name: 'Trustkill Records',
    color: 'text-purple-400',
    bg: 'bg-purple-400/10',
    border: 'border-purple-400/20',
    pressContact: 'Trustkill Records',
    pressEmail: 'jeff@trustkill.com',
    website: 'https://trustkill.com',
    artists: [
      'Bleeding Through', 'From Autumn to Ashes', 'Poison the Well',
      'Shadows Fall', 'The Bled', 'With Honor',
    ],
  },
  purenoise: {
    name: 'Pure Noise Records',
    color: 'text-green-400',
    bg: 'bg-green-400/10',
    border: 'border-green-400/20',
    pressContact: 'Pure Noise Records PR',
    pressEmail: 'press@purenoise.net',
    website: 'https://purenoise.net',
    artists: [
      'Knocked Loose', 'Citizen', 'Microwave', 'Charmer', 'Anxious',
      'Militarie Gun', 'Zulu', 'SeeYouSpaceCowboy', 'Dying Wish',
      'Koyo', 'Scowl', 'Pool Kids', 'MSPAINT', 'Narrow Head',
      'Mannequin Pussy', 'As It Is',
    ],
  },
};

export const OUTREACH_STATUS = {
  pending:     { label: 'Not Contacted', color: 'text-neutral-400', bg: 'bg-neutral-800',      border: 'border-neutral-700'    },
  contacted:   { label: 'Contacted',     color: 'text-blue-400',    bg: 'bg-blue-400/10',      border: 'border-blue-400/20'    },
  approved:    { label: 'Approved',      color: 'text-emerald-400', bg: 'bg-emerald-400/10',   border: 'border-emerald-400/20' },
  declined:    { label: 'Declined',      color: 'text-red-400',     bg: 'bg-red-400/10',       border: 'border-red-400/20'     },
  noResponse:  { label: 'No Response',   color: 'text-amber-400',   bg: 'bg-amber-400/10',     border: 'border-amber-400/20'   },
};

export function generatePressEmail(concert) {
  const label = LABELS[concert.label];
  const dateStr = concert.date
    ? new Date(concert.date).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })
    : 'the upcoming show';

  const subject = `Media Coverage Request — ${concert.artist} at ${concert.venue}, ${concert.city}`;

  const body = `Hi ${label?.pressContact || 'there'},

My name is Mike with Black Magic Films. I'm a videographer and filmmaker based in the Yardley, PA area, specializing in cinematic music and brand content shot on Blackmagic Cinema 6K.

I'm reaching out to request a media/photo pass for the upcoming show:

  Artist: ${concert.artist}
  Venue:  ${concert.venue} — ${concert.city}, ${concert.state}
  Date:   ${dateStr}

I'd love to capture professional video and photo content from the show. My recent work includes projects with Jersey Joint Dispensary, Kevin Smith's The Secret Stash, and local artists across the Philadelphia/NJ area.

Portfolio:
  Film Reel:   blackmagicfilms.com/reel
  Photography: blackmagicfilms.com/photography
  Instagram:   @blackmagicfilms_

I'm happy to work within any house restrictions and can provide a shot list or references on request. Please let me know if this is something you'd be open to.

Thank you for your time.

Mike
Black Magic Films
mike@blackmagicfilms.com
blackmagicfilms.com`;

  return { subject, body };
}
